import * as React from 'react';
import { useDispatch } from 'react-redux';
import { ModalContainer } from '@moovly/ui';
import { t } from '@moovly/i18n';

import useMembers from '../../../hooks/useMembers';
import { deleteMember } from '../../../store/members.store';
import { DefaultModalProps } from '../../../types/modal';

export interface RemoveMemberProps {
  userId: string;
  name: string;
}

export interface RemoveMemberModalProps extends DefaultModalProps {
  user: RemoveMemberProps;
}
export const RemoveMemberModal: React.FC<RemoveMemberModalProps> = ({ user, closeModal, setOpen }) => {
  const dispatch = useDispatch<any>();
  const { members } = useMembers();
  const userMembers = React.useMemo(() => members.filter((m) => m.user_id === user?.userId), [members, user]);
  const handleConfirm = React.useCallback(() => {
    if (!!user) {
      userMembers.forEach((member) => {
        dispatch(
          deleteMember({
            groupId: member.group_id!,
            memberId: member.id,
          })
        );
      });
    }

    closeModal();
  }, [dispatch, userMembers, user, closeModal]);

  return (
    <ModalContainer
      title={t('deleteModal.title')}
      description={`${t('deleteModal.descriptionStart')} ${user?.name} ${t('deleteModal.descriptionEnd')}`}
      isOpen={!!user}
      confirmButtonText={t('actions.delete.yes')}
      onConfirm={handleConfirm}
      onClose={closeModal}
      setOpen={setOpen}
    />
  );
};

export default RemoveMemberModal;
